import { api } from "../middlewares";

async function getEtapas() {
  try {
    let resultGetEtapasFinanciamento = await api.get(
      "MeAjuda/GetEtapasFinanciamento"
    );
    return resultGetEtapasFinanciamento.data;
  } catch (error) {
    return error.request;
  }
}

async function getPerguntasFrequentes() {
  try {
    let resultGetPerguntasFrequentes = await api.get(
      "MeAjuda/GetPerguntasFrequentes"
    );
    return resultGetPerguntasFrequentes.data;
  } catch (error) {
    return error.request;
  }
}

async function getComoOndeFinanciar() {
  try {
    let resultGetComoOndeFinanciar = await api.get("MeAjuda/ComoOndeFinanciar");
    return resultGetComoOndeFinanciar.data;
  } catch (error) {
    return error.request;
  }
}

async function getEstados() {
  try {
    let resultGetEstados = await api.get("MeAjuda/GetEstados");

    return resultGetEstados.data;
  } catch (error) {
    return [];
  }
}

async function getMunicipios(IdEstado) {
  try {
    let resultGetMunicipios = await api.get("MeAjuda/GetMunicipios", {
      params: { IdEstado },
    });
    return resultGetMunicipios.data;
  } catch (error) {
    return error.request;
  }
}

async function registraAtendimento(dadosCliente) {
  return await api.post("MeAjuda/PrecisoDeAjuda", {
    ...dadosCliente,
  });
}

export {
  getEtapas,
  getPerguntasFrequentes,
  getComoOndeFinanciar,
  getEstados,
  getMunicipios,
  registraAtendimento,
};
